<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div class="flex">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small"/>
				<el-button type="warning" style="margin-left: 10px;" @click="getTableData" size="small">搜索</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">拼团状态</div>
				<el-select v-model="status" placeholder="请选择" class="titleSelect" @change="getTableData" size="small">
					<el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">拼团时间</div>
				<el-date-picker v-model="dateValue" type="datetimerange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" @change="handelSearchClick" size="small" class="titleDate">
				</el-date-picker>
			</div>
			<div>
				<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<div class="tableView" :style="{height:fixedHeight-82+'px'}">
			<el-table :data="tableData" size="small">
				<el-table-column prop="no" label="拼团编号" :key="1" align="center">
					<template slot-scope="scope">
						{{scope.row.no == null?'--':scope.row.no}}
					</template>
				</el-table-column>
				<el-table-column label="开团时间" :key="2" align="center">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.create_info.operation_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="group_book_goods_info.title" label="拼团名称" :key="3" align="center">
				</el-table-column>
				<el-table-column label="发起人" :key="5" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.order_list[0].user_address.nick_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="手机号" :key="6" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.order_list[0].user_address.user_mobile}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="拼团人数" :key="8" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.order_list.length}}/{{scope.row.group_book_goods_info.people}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="结束时间" :key="9" align="center">
					<template slot-scope="scope">
						<span>{{$public.FTime(scope.row.group_book_goods_info.end_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" :key="10" align="center">
					<template slot-scope="scope"> 
						<el-button type="text" size="small" @click="handelSeeClick(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total"  :pageSize='page.page_size' @change="changePage" style="padding: 10px 0;"></page>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import {
		getBookGoodsList
	} from '../../../api/program.js'
	export default {
		components: {
			page
		},
		data() {
			return {
				fixedHeight:'',
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				dateValue: [], //活动日期
				keyword: '', //搜索框
				tableData: [], //表格数据
				status:-1,  //拼团状态
				statusOptions:[{
					name:'全部',
					id:-1
				},{
					name:'拼团中',
					id:1
				},{
					name:'拼团成功',
					id:2
				},{
					name:'拼团失败',
					id:3
				}]
			}
		},
		created(){
			this.fixedHeight = document.documentElement.clientHeight - 86;
		},
		mounted() {
			this.getTableData()
		},
		methods:{
			//跳转详情
			handelSeeClick(row){
				this.$router.push({
					path:'detail',
					query:{
						item:row,
					}
				})
			},
			handelSearchClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//重置
			handleResetClick(){
				this.keyword = '';
				this.status = -1,
				this.dateValue = [];
				this.getTableData()
			},
			//表格方法
			getTableData(){
				let startTime = '';
				let endTime = '';
				console.log(this.dateValue)
				if(this.dateValue.length == 0){
					startTime = '';
					endTime = '';
				}else{
					startTime = new Date(this.dateValue[0]).getTime()/1000;
					endTime = new Date(this.dateValue[1]).getTime()/1000;
				}
				let params = {
					page_index: this.page.page,
					page_size:this.page.pageSize,
					keyword:this.keyword,
					status:this.status,
					start_time:startTime,
					end_time:endTime
				}
				// console.log(params)
				getBookGoodsList(params).then((res)=>{
					if(res.code == 0){
						console.log(res.data)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		padding: 0 10px;
		font-size: 14px;

		.titleInput {
			width: 192px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-right: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
	}

	.tableView {
		background: #fff;
	}
</style>
